<template>
    <div class="w-screen h-screen flex flex-col overflow-auto">
        <div class="flex">
            <h2 class="text-primary mx-auto my-auto text-xl md:text-5xl">Publicar Nuevo Vestido</h2>
        </div>
        <form class="w-full max-w-lg p-2 mx-auto ">
            <div class="flex flex-wrap -mx-3 mb-2">
                <div class="w-full md:w-1/2 px-3 mb-2 md:mb-0">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                        Nombre
                    </label>
                    <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" placeholder="" v-model="nombre">
                    <p class="text-red-500 text-xs italic">Porfavor llenar este campo.</p>
                </div>
                <div class="w-full md:w-1/2 px-3">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-last-name">
                        Colección
                    </label>
                    <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-last-name" type="text" placeholder="" v-model="coleccion">
                </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-2">
                <div class="w-full px-3">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-password">
                        DescripciÓn
                    </label>
                    <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-description" type="text" v-model="descripcion">
                    <p class="text-gray-600 text-xs italic">Tan extensa y loca como deseen.</p>
                </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-2">
                <div class="w-full px-3">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-password">
                        Precio
                    </label>
                    <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-description" type="number" v-model="precio">
                    <p class="text-gray-600 text-xs italic">Dos puntos decimales separados por punto. Ej: 29.99 o 30.00</p>
                </div>
            </div>
            <div class="flex flex-wrap -mx-3 mb-2 mt-2">
                <div class="w-full md:w-2/3 px-3 mb-6 md:mb-0">
                    <div class="flex items-center">
                        <div>
                            <label for="colorSelected" class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">Color</label>
                            <input disabled id="colorSelected" type="text" placeholder="Pick a color" class="border border-transparent shadow px-4 py-2 leading-normal text-gray-700 bg-white rounded-md focus:outline-none focus:shadow-outline" v-model="colorSelected">
                        </div>
                        <div class="relative ml-3 mt-6">
                            <button type="button" @click="isOpen = !isOpen" class="w-8 h-8 rounded-full focus:outline-none focus:shadow-outline inline-flex  shadow" :style="`background: ${colorSelected}; color: white`">
                                <svg class="w-6 h-6 my-auto mx-auto fill-current" viewBox="0 0 24 24">
                                    <path fill="none" d="M15.584 10.001L13.998 8.417 5.903 16.512 5.374 18.626 7.488 18.097z" />
                                    <path d="M4.03,15.758l-1,4c-0.086,0.341,0.015,0.701,0.263,0.949C3.482,20.896,3.738,21,4,21c0.081,0,0.162-0.01,0.242-0.03l4-1 c0.176-0.044,0.337-0.135,0.465-0.263l8.292-8.292l1.294,1.292l1.414-1.414l-1.294-1.292L21,7.414 c0.378-0.378,0.586-0.88,0.586-1.414S21.378,4.964,21,4.586L19.414,3c-0.756-0.756-2.072-0.756-2.828,0l-2.589,2.589l-1.298-1.296 l-1.414,1.414l1.298,1.296l-8.29,8.29C4.165,15.421,4.074,15.582,4.03,15.758z M5.903,16.512l8.095-8.095l1.586,1.584 l-8.096,8.096l-2.114,0.529L5.903,16.512z" /></svg>
                            </button>
                            <div v-show="isOpen" @click="isOpen = false" class="origin-top-right absolute right-0 mt-8 w-40 rounded-md shadow-lg z-50 bg-secondary">
                                <div class="rounded-md bg-white shadow-xs px-4 py-3">
                                    <div class="flex flex-wrap -mx-2">
                                        <template v-for="(color) in colors" v-bind:index="color">
                                            <div class="px-2" v-bind:key="color">
                                                <template v-if="colorSelected === color">
                                                    <div class="w-8 h-8 inline-flex rounded-full cursor-pointer border-4 border-secondary" :style="`background: ${color}; box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.3);`"></div>
                                                </template>
                                                <template v-if="colorSelected != color">
                                                    <div @click="colorSelected = color" @keydown.enter="colorSelected = color" role="checkbox" tabindex="0" :aria-checked="colorSelected" class="w-8 h-8 inline-flex rounded-full cursor-pointer border-4 border-white focus:outline-none focus:shadow-outline" :style="`background: ${color};`"></div>
                                                </template>
                                            </div>
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="w-full md:w-1/2 px-3 mb-6 md:my-2 ">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-state">
                        Talla
                    </label>
                    <div class="relative">
                        <select multiple size="5" class="block appearance-none w-full bg-secondary border border-primary text-primary py-3 px-4 pr-8 rounded leading-tight focus:text-secondary focus:text-opacity-75 focus:outline-none focus:bg-primary focus:border-secondary" id="grid-state" v-model="talla">
                            <option>XS</option>
                            <option>S</option>
                            <option>M</option>
                            <option>L</option>
                            <!-- <option>LG</option> -->
                            <option>XL</option>
                            <option>1XL</option>
                            <option>2XL</option>
                            <option>3XL</option>
                            <option>4XL</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-primary">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                        <p class="text-gray-600 text-xs italic">Para seleccionar varios, Ctrl + Click </p>
                    </div>
                </div>
                <div class="w-full md:w-1/2 px-3 mb-6 md:my-2 ">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-state">
                        Venta o Alquiler
                    </label>
                    <div class="relative">
                        <select class="block appearance-none w-full bg-secondary border border-primary text-primary py-3 px-4 pr-8 rounded leading-tight focus:text-secondary focus:text-opacity-75 focus:outline-none focus:bg-primary focus:border-secondary" id="grid-state" v-model="tipo">
                            <option>Alquiler</option>
                            <option>Venta</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-primary">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>
                <div class="w-full md:w-1/2 px-3 mb-6 md:my-2 ">
                    <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-state">
                        Largo o Corto
                    </label>
                    <div class="relative">
                        <select class="block appearance-none w-full bg-secondary border border-primary text-primary py-3 px-4 pr-8 rounded leading-tight focus:text-secondary focus:text-opacity-75 focus:outline-none focus:bg-primary focus:border-secondary" id="grid-state" v-model="estilo">
                            <option>Largo</option>
                            <option>Corto</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-primary">
                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>
                <div class="w-full hidden md:w-1/2 px-3 mb-6 md:mb-0 md:my-2">
                    <label class="block uppercase tracking-wide text-xs font-bold mb-2" for="grid-zip">
                        Material
                    </label>
                    <input class="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500" id="grid-zip" type="text" placeholder="" v-model="material">
                </div>
            </div>
            <div class="w-full items-center justify-center flex">
                <img :src="imageUrl" style="max-height: 6rem;" class="m-2">
            </div>
            <div v-if="cargando" class="w-full items-center justify-center flex">
                <p class="text-3xl"> Cargando ... </p>
            </div>
            <div class="mb-24 md:flex md:items-center md:mb-0
            ">
                <input type="file" style="display: none" ref="fileInput" accept="image/*" @change="onFilePicked">
                <div class="md:w-2/3 flex justify-center md:justify-start">
                    <button class="shadow bg-primary hover:bg-purple-400 focus:shadow-outline focus:outline-none text-secondary font-bold py-2 px-4 rounded" type="button" @click="onPickFile">
                        <div class="flex">
                            Imagen <span class="material-icons text-secondary mx-1">attachment</span>
                        </div>
                    </button>
                </div>
                <div class="my-2  md:w-1/3 flex justify-center md:justify-end ">
                    <button class="shadow border border-primary focus:shadow-outline focus:outline-none text-primary font-bold py-2 px-4 rounded" type="button" @click="onCreateDress">
                        Agregar
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
//import Carousel from '@/components/admin/carousel-admin.vue'
export default {
    components:{
        //Carousel
    },
    data() {
        return {
            isOpen: false,
            colors: ['#FFF','#1a1a1a','#c4c2c4', '#ffdd00','#2196F3', '#cf0000', '#f5742a', '#a600ff', '#f78fe4', '#661923', '#fff8e7', '#2e8b57', '#8d6740'],
            colorSelected: '#c4c2c4',
            nombre: '',
            coleccion: 'Colección',
            precio: 0,
            descripcion: '',
            image: null,
            imageUrl: '',
            talla: ['M', 'XL'],
            material: 'Material',
            tipo: 'Alquiler',
            estilo: 'Largo',


        }
    },
    computed: {
        ...mapGetters(['getLoading']),
        formIsValid() {
            return this.nombre !== '' &&
                this.coleccion !== '' &&
                this.descripcion !== '' &&
                this.imageUrl !== ''
        },
        cargando(){
            return this.getLoading
        }
    },
    methods: {
        ...mapActions(['newVestido']),
        onPickFile() {
            this.$refs.fileInput.click()
        },
        onFilePicked(event) {
            const files = event.target.files
            let filename = files[0].name
            if (filename.lastIndexOf('.') <= 0) {
                return alert('Please add a valid file!')
            }
            const fileReader = new FileReader()
            fileReader.addEventListener('load', () => {
                this.imageUrl = fileReader.result
            })
            fileReader.readAsDataURL(files[0])
            this.image = files[0]
        },
        onCreateDress() {
            if (!this.formIsValid) {
                this.$store.commit('showMessage', { content: 'Faltan datos del producto!', color: 'error' })
                return
            }
            if (this.image == null) {
                this.$store.commit('showMessage', { content: 'No ha incluido una imagen de producto!', color: 'error' })
                return
            }
            const vestido = {
                nombre: this.nombre,
                coleccion: this.coleccion,
                image: this.image,
                descripcion: this.descripcion,
                talla: this.talla,
                material: this.material,
                color: this.colorSelected,
                tipo: this.tipo,
                estilo: this.estilo,
                precio: this.precio,
            }
            this.newVestido(vestido)
            this.colorSelected = '#c4c2c4'
            this.nombre = ''
            this.coleccion = 'Colección'
            this.descripcion = ''
            this.image = null
            this.imageUrl = ''
            this.talla = ['M', 'XL']
            this.material = 'Material'
            this.tipo = 'Alquiler'
            this.estilo = 'Largo',
            this.precio = 0
            //this.$router.push('/')
        },
    }
}
</script>
<style scoped>
.conte{
    max-height: 100vh;
}
</style>